export class GroupBudget {

  Oid: number = 0;
  Expense: number | null = 0;
  GroupCode: string | null = null;

  constructor(public GroupOid: number | null, public Year: number, public Amount: number) {}

}
